//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

(function() {
  angular.module('curalate').component('searchFilterNestedCheckbox', {
    bindings: {
      searchFilterSetName: '<',
      key: '@',
      value: '@',
      label: '@',
      showLabelOnly: '<',
    },
    transclude: {
      label: '?searchFilterLabel',
      content: '?searchFilterContent',
    },
    template: require('@legacy-components/filters/search-filter-nested-checkbox/search-filter-nested-checkbox.html'),
    controller: [
      '$attrs',
      'INDETERMINATE_CHECKBOX_STATES',
      'rx',
      'SearchFilterNestedCheckboxService',
      function(
                $attrs,
                INDETERMINATE_CHECKBOX_STATES,
                rx,
                SearchFilterNestedCheckboxService,
            ) {
        const self = this;
        const ngUnsubscribe = new rx.Subject();
        self.checkboxState = INDETERMINATE_CHECKBOX_STATES.UNCHECKED;

        let nestedCheckbox;

        self.hasChildren = function() {
          return nestedCheckbox.children.length > 0;
        };

        self.onStateChange = function(checkboxState) {
          nestedCheckbox.changeState(checkboxState, self.trackingLabel);
        };

        self.toggleIsExpanded = function() {
          self.isExpanded = !self.isExpanded;
        };

        self.$onInit = function() {
          self.isExpanded = true;
          self.trackingLabel = $attrs.trackingLabel;
          nestedCheckbox = SearchFilterNestedCheckboxService.getNestedCheckbox(self.searchFilterSetName, self.key, self.value);
          nestedCheckbox.getValue().takeUntil(ngUnsubscribe).subscribe((newCheckboxState) => {
            self.checkboxState = newCheckboxState;
          });
        };

        self.$onDestroy = function() {
          ngUnsubscribe.next();
          ngUnsubscribe.complete();
        };
      },
    ],
  });
})();
